export default __webpack_public_path__ + "488099936910c6f04da27a37faf380a0.jpg";